var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',[_vm._l((this.mapData.features),function(feature,i){return [_c('path',{key:i,style:(_vm.featureStyle(feature)),attrs:{"name":feature.properties['NAME_1'],"d":_vm.path(feature.geometry)}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }